import React, { Component } from 'react';
import Sidebar from '../../Common/Sidebar/Sidebar'
import Cards from '../../Common/DashboardCard/Cards'
import SearchForm from './SearchForm'
import SearchResults from './SearchResults'
import './Dashboard.css'
import getDepartments from '../../services/departmentsService'
import search  from '../../services/dashboardService'
import Loader from "react-loader-spinner";
class Dashboard extends Component {
    state = { 
        user:{},
        departments:[],
        showSearchResults:false,
        searchResults:[],
        isFetching:false,
        isLoading:true,
        error:false,
        isSearching:false,
        errorMessage:"",
        searchParams:{
            department:"",
            keyword:""
        }

     }
     componentDidMount = async() => {
        let loggedInUser = localStorage.getItem('currentUser')
        let response = await getDepartments.fetchAllDepartments()
        loggedInUser = JSON.parse(loggedInUser)
        let departments = response.data
        this.setState({user:loggedInUser})
        this.setState({departments})
        this.setState({isLoading:false})
     };
     searchDocument = async(e) =>{
         e.preventDefault()
         this.setState({isSearching:true})
        try {
            let {department , keyword} = this.state.searchParams
            let response = await search.searchDocumentAPI(department,keyword)
            let searchResults = await response.data
            this.setState({searchResults})
            this.setState({showSearchResults:true})
            this.setState({isSearching:false})
        } catch (error) {
            let errorMessage = error.response.data.message
            this.setState({errorMessage})
            this.setState({error:true})
            this.setState({isSearching:false})
        }
         
     }
     closeError = () =>{
        this.setState({error: false})
     }
     clearSearch = () =>{
        let searchParams = { ...this.state.searchParams}
        searchParams.department = ""
        searchParams.keyword = ""
        this.setState({searchParams})
        this.setState({showSearchResults:false})
     }
     changeDepartment = (event) =>{
         let searchParams = { ...this.state.searchParams}
         searchParams.department = event.target.value
         this.setState({searchParams})
        }
        handleChangeKeyword =(event) =>{
         let searchParams = { ...this.state.searchParams}
         searchParams.keyword = event.target.value
         this.setState({searchParams})
     }
    render() { 
        let { user,showSearchResults,departments , isFetching,error,isSearching } = this.state
        let {department , keyword} = this.state.searchParams
        return ( 
            this.state.isLoading ? 
            <div className="flex justify-center items-center h-screen">
                	<Loader type="Oval" className="align-middle" color="#F35D2D" height={100} width={100}/>
            </div> 
            :
            <div className="flex flex-row w-full ">
            <div className=" p-4 bg-white  md:min-h-screen w-60 fixed">
            <Sidebar user={user}/>
            </div>
            <div className="py-8 px-8 ml-60 upPart relative lg:max-h-72 w-full">
                   <div className="">
                      <Cards user={user}/>
                   </div>
                   <div>
                        <SearchForm
                         searchDocument = {this.searchDocument}
                         showSearchResults={showSearchResults}
                         clearSearch={this.clearSearch}
                         departments = {departments}
                         departmentToSearchIn = {department}
                         keywordToSearch ={keyword}
                         changeDepartment = {this.changeDepartment}
                         handleChangeKeyword = {this.handleChangeKeyword}
                         isSearching = {isSearching}
                         />
                   </div>
                   {
                       //searchResults Form
                      showSearchResults &&
                      <div>
                         <SearchResults isFetching={isFetching} searchResults={this.state.searchResults}/>
                      </div>
                   }
                </div>
                {
                     error && (
                        <div className="fixed top-8 right-0 bg-red-500 w-80 text-xs z-20 border-2 border-red-800 rounded-md">
                           <div className="flex flex-row py-2 px-4 gap-4">
                               <div className=" bg-red-500 p-1 rounded-md">
                                   <div className="bg-white rounded-full p-1">
                                       <p className=""><svg className="w-5 h-5 cursor-pointer text-red-500" onClick={() => this.closeError ()} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" /></svg></p>
                                   </div>
                               </div>
                               <div className="flex items-center">
                                   <p className="text-white">{this.state.errorMessage}</p>
                               </div>
                           </div>
                        </div>
                           )
                       }
                
            </div>
         );
    }
}
 
export default Dashboard;